<template>
    <div class="account">
        <div class="action-header">
            <div class="action-header__title">
                {{title}}
            </div>
            <div class="action-header__date-picker">
                <vue-date-picker :disabled-date="(date) => date >= disabledAfter" range-separator=" " :formatter="customFormat" v-model="time" :shortcuts="shortcuts" range format="DD/MM/YYYY"></vue-date-picker>
            </div>
        </div>
        <div class="account__actions actions">
            <div class="actions__search-container">
                <input @input="applySearch" class="actions__search-input" v-model="filter.query" type="text" placeholder="Search by IP"/>
                <inline-svg
                    class="actions__search-icon"
                    src="/images/search.svg" aria-label="search">
                </inline-svg>
                <inline-svg
                    v-show="filter.query"
                    @click="clearSearch()"
                    class="clear-search"
                    src="/images/clear.svg" aria-label="clear">
                </inline-svg>
            </div>
            <div class="actions__add-filter__wrapper">
                <data-filter @filterApply='applyFilter' v-bind:filtersInit="filtersDataComponent"></data-filter>
            </div>
        </div>

        <div class="account__table main-table">
            <table class="main-table__wrapper">
                <thead class="main-table__header">
                    <th class="main-table__header-item">
                        <span id="created_at" @click="sortTable($event, 'created_at', 'ASC')" class="table-header-sort noselect">
                            <span>
                                Blocked on
                            </span>
                            <span class="sort-col-wrapper">
                                <inline-svg
                                    class="sort-icon sort-icon-desc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                                <inline-svg
                                    class="sort-icon sort-icon-down sort-icon-asc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                            </span>
                        </span>
                    </th>
                    <th class="main-table__header-item">
                        <span @click="sortTable($event, 'ip', 'ASC')" class="table-header-sort noselect">
                            <span>
                                IP
                            </span>
                            <span class="sort-col-wrapper">
                                <inline-svg
                                    class="sort-icon sort-icon-desc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                                <inline-svg
                                    class="sort-icon sort-icon-down sort-icon-asc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                            </span>
                        </span>
                    </th>
                    <th class="main-table__header-item">
                        <span @click="sortTable($event, 'block_reason_id', 'ASC')" class="table-header-sort noselect">
                            <span>
                                Blocking reason
                            </span>
                            <span class="sort-col-wrapper">
                                <inline-svg
                                    class="sort-icon sort-icon-desc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                                <inline-svg
                                    class="sort-icon sort-icon-down sort-icon-asc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                            </span>
                        </span>
                    </th>
                    <th class="main-table__header-item">
                    <span @click="sortTable($event, 'account_name', 'ASC')" class="table-header-sort noselect">
                        <span>
                            Google Ads Account
                        </span>
                        <span class="sort-col-wrapper">
                            <inline-svg
                                class="sort-icon sort-icon-desc"
                                src="/images/up-arrow.svg" aria-label="PPCShield">
                            </inline-svg>
                            <inline-svg
                                class="sort-icon sort-icon-down sort-icon-asc"
                                src="/images/up-arrow.svg" aria-label="PPCShield">
                            </inline-svg>
                        </span>
                    </span>
                    </th>
                    <th class="main-table__header-item">
                        <span @click="sortTable($event, 'campaign_name', 'ASC')" class="table-header-sort noselect">
                            <span>
                                Campaign
                            </span>
                            <span class="sort-col-wrapper">
                                <inline-svg
                                    class="sort-icon sort-icon-desc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                                <inline-svg
                                    class="sort-icon sort-icon-down sort-icon-asc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                            </span>
                        </span>
                    </th>
                    <th class="main-table__header-item">
                        <span class="table-header-sort noselect">
                            <span></span>
                        </span>
                    </th>
                </thead>
                <tbody class="main-table__body">
                    <template v-if="isLoading" >
                        <tr class="main-table__row-container">
                            <td class="main-table__row-item" colspan="6">
                                <div class="loader">
                                    <svg class="circular" viewBox="25 25 50 50">
                                        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
                                    </svg>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-else-if="tableData && tableData.length">
                        <template v-for="item in tableData">
                            <tr :class="{
                                    'main-table__row-container': true,
                                    'blocking-click-info-bgc': expand_click_id === item.click_id,
                                }"
                            >
                                <td class="main-table__row-item not-pointer-column">
                                    {{ item.created_at }}
                                </td>
                                <td class="main-table__row-item not-pointer-column">
                                    <img v-if="item.country_code"
                                         class="country-flag"
                                         :src="'http://purecatamphetamine.github.io/country-flag-icons/3x2/'+item.country_code+'.svg'" alt="country flag"
                                         data-toggle="tooltip" data-placement="bottom" :title="item.country_name">
                                    <span v-else
                                          class="empty-country-flag"
                                          data-toggle="tooltip" data-placement="bottom" title="Unavailable"></span>
                                    <span style="margin-left: 5px;">{{ item.ip }}</span>
                                </td>
                                <td class="main-table__row-item not-pointer-column">
                                    <show-blocking-reason :reason="item.block_reason"></show-blocking-reason>
                                </td>
                                <td class="main-table__row-item not-pointer-column">
                                    {{ item.account_name }}
                                </td>
                                <td class="main-table__row-item not-pointer-column">
                                    {{ item.campaign_name }}
                                </td>
                                <td class="main-table__row-item" @click="onExpandClickInfo(item.click_id)">
                                    <inline-svg
                                        v-if="expand_click_id === item.click_id"
                                        class="main-table__check-icon default s-h-auto"
                                        style="width: 40px;"
                                        src="/images/icons/expand_less.svg" aria-label="reason">
                                    </inline-svg>
                                    <inline-svg
                                        v-else
                                        class="main-table__check-icon default s-h-auto"
                                        style="width: 40px;"
                                        src="/images/icons/expand_more.svg" aria-label="reason">
                                    </inline-svg>
                                </td>
                            </tr>
                            <tr v-if="expand_click_id === item.click_id">
                                <td colspan="6" class="blocking-click-info-bgc">
                                    <blocked-click-info
                                        :click_id="item.click_id"
                                        :initial_click_id="item.initial_click_id"
                                    ></blocked-click-info>
                                </td>
                            </tr>
                        </template>
                    </template>
                    <template v-else>
                        <tr class="main-table__row-container">
                            <td class="main-table__row-item" colspan="6">Not found</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <div class="pagination-container">
            <span v-if="pages" class="mr-5">Show rows {{page * 20 - 19}} - {{page == pages ? pages_rows : page * 20}} of {{pages_rows}}</span>
            <paginate v-if="pages"
                      :v-model="page"
                      :page-count="pages"
                      :click-handler="getPage"
                      :prev-text="'Prev'"
                      :next-text="'Next'"
                      :container-class="'pagination mb-0'"
                      :page-class="'page-item'">
            </paginate>
        </div>
    </div>
</template>

<script>
    import {blockedIpTable} from '../../helpers/blocked-ip-table';
    import {dateShortCuts, defaultDateRange, setCookiesDateRange, dateToString, stringToDate} from "../../helpers/date-converter";
    import Paginate from 'vuejs-paginate';

    export default {
        name: 'blocked-ip',
        props: ['campaign_id', 'title'],
        components: {
            Paginate
        },
        data: function () {
            return {
                isLoading: false,
                tableData: null,
                pages: null,
                pages_rows: null,
                page: 1,
                filter: {
                    query: '',
                    page: 1,
                    campaign_id: 'null',
                    tags: {},
                    sort: {
                        'column': '',
                        'sort': '',
                    }
                },
                time: defaultDateRange(),
                shortcuts: dateShortCuts(),
                filtersDataComponent: null,
                disabledAfter: this.$moment(moment().add(1, 'day').format("DD-MM-YYYY"), "DD-MM-YYYY"),
                crutch_for_date_picker: false,

                expand_click_id: null,
            }
        },
        computed: {
            customFormat() {
                return {
                    stringify: (date) => {
                        if(moment(this.time[1]).format('L') === moment(this.time[0]).format('L')){
                            if(!this.crutch_for_date_picker){
                                this.crutch_for_date_picker = true;
                            }
                            else  {
                                this.crutch_for_date_picker = false;
                            }
                            return date
                                ? this.crutch_for_date_picker
                                    ? moment(date).format('L') === moment(this.time[0]).format('L')
                                        ? dateToString(moment(this.time[0]).format('MMM D YYYY'), moment(this.time[1]).format('MMM D YYYY'))
                                        : ''
                                    : ''
                                : ''
                        }
                        else{
                            return date
                                ? moment(date).format('L') === moment(this.time[0]).format('L')
                                    ? dateToString(moment(this.time[0]).format('MMM D YYYY'), moment(this.time[1]).format('MMM D YYYY'))
                                    : ''
                                : ''
                        }
                    },
                    parse: (value) => {
                        return value
                            ? this.calcDateFormatToDate()
                            : null
                    },
                }
            }
        },
        methods: {
            onExpandClickInfo(click_id){
                if(this.expand_click_id === click_id) this.expand_click_id = null;
                else this.expand_click_id = click_id;
            },
            calcDateFormatToDate(){
                let stringDate = $('.action-header__date-picker .mx-input-wrapper input').val();
                let tempTime = stringToDate(stringDate);
                if(tempTime[0].isValid() &&
                    tempTime[1].isValid() &&
                    (moment(this.time[0]).format('MMM D YYYY') !== moment(tempTime[0]).format('MMM D YYYY') ||
                        moment(this.time[1]).format('MMM D YYYY') !== moment(tempTime[1]).format('MMM D YYYY')))
                {
                    this.time = [tempTime[0].toDate(), tempTime[1].toDate()];
                    this.getChartData();
                }
                return null;
            },
            sortTable(event, column, type) {
                $(".sort-icon").removeClass("active-sort");
                let element = $(event.currentTarget);
                if(column === this.filter.sort.column) {
                    if(this.filter.sort.type === 'ASC') {
                        type = 'DESC';
                        $(element).find(".sort-icon-asc").addClass("active-sort");
                    }
                    /*else if(this.filter.sort.type === 'DESC') {
                        type = '';
                    }*/
                    else {
                        type = 'ASC';
                        $(element).find(".sort-icon-desc").addClass("active-sort");
                    }
                } else {
                    $(element).find(".sort-icon-desc").addClass("active-sort");
                }
                this.filter.sort.column = column;
                if(type === '') this.filter.sort.column = '';
                this.filter.sort.type = type;
                this.getBlockedData();
            },
            clearSearch() {
                this.filter.query = '';
                this.getBlockedData();
            },
            getBlockedData() {
                const last_search_value = this.filter.query;
                if(this.isLoading) return;
                this.isLoading = true;
                this.filter.campaign_id = this.campaign_id;
                axios.get('blocked/total',{
                    params: {
                        query: this.filter.query,
                        page: this.filter.page,
                        campaign_id: this.filter.campaign_id,
                        column: this.filter.sort.column,
                        type: this.filter.sort.type,
                        date_from: this.time[0] ? moment(this.time[0]).format() : '',
                        date_to: this.time[1] ? moment(this.time[1]).format() : '',
                        //timezone: new Date().getTimezoneOffset(),
                        filters: this.filter.tags,
                    }
                })
                .then(info => {
                    this.isLoading = false;
                    if(last_search_value === this.filter.query){
                        const {data: {items = []}} = info;
                        this.tableData = blockedIpTable(items);
                        this.pages_rows = info.data.total_rows;
                        this.pages = info.data.total;
                        setTimeout(() => {
                            $(function () {
                                $('[data-toggle="tooltip"]').tooltip()
                            })
                        },0);
                    }
                    else{
                        this.getBlockedData();
                    }
                })
                .catch(err => {
                    this.isLoading = false;
                    console.log('err', err);
                });
            },
            getFiltersData() {
                axios.get('blocked/totalled', {
                    params: {campaign_id: this.filter.campaign_id}
                })
                    .then(info => {
                        this.filtersDataComponent = info.data.items;
                    })
                    .catch(err => console.log('err', err));
            },
            applySearch() {
                this.page = 1;
                this.filter.page = 1;
                this.getBlockedData();
            },
            applyFilter(data) {
                this.filter.tags = data.filter_data;
                this.page = 1;
                this.filter.page = 1;
                this.getBlockedData();
            },
            getPage: function (pageNum) {
                this.page = pageNum;
                this.filter.page = pageNum;
                this.getBlockedData()
            },
            setAllTimeDatePicker(){
                axios.get('/account/getStartAllTimeDate')
                    .then(response => {
                        this.shortcuts = dateShortCuts(response.data);
                    });
            },
        },
        mounted() {
            this.setAllTimeDatePicker();

            setTimeout(() => {$('#created_at').find(".sort-icon-asc").addClass("active-sort");}, 200);
            this.filter.sort.column = 'created_at';
            this.filter.sort.type = 'DESC';

            this.getBlockedData();
            this.getFiltersData();
        },
        watch: {
            time: function(val) {
                setCookiesDateRange(val[0], val[1]);
                this.getBlockedData();
            }
        }
    }
</script>
